(function () {
    document.addEventListener("DOMContentLoaded", function () {
        // Select change events
        let page = document.querySelector(".load-more");

        function filterCareers() {
            // Output
            let output = document.getElementById("filter-output");
            let loadMoreButton = document.querySelector(".load-more");
            loadMoreButton.setAttribute("data-page", "1");

            let choicesData = "";

            output.innerHTML =
                '<div class="loader btn-loading w-100"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 0C4.824 0 0.553781 3.954 0.0507812 9H2.06836C2.56336 5.06 5.928 2 10 2C14.072 2 17.4366 5.06 17.9316 9H19.9492C19.4452 3.954 15.176 0 10 0ZM0.0507812 11C0.250781 13.008 1.05458 14.8374 2.26758 16.3184L3.6875 14.8984C2.8295 13.7924 2.25136 12.457 2.06836 11H0.0507812ZM16.2715 14.9297C15.8575 15.4547 15.3855 15.9328 14.8555 16.3398L15.8672 18.0742C16.6802 17.4832 17.399 16.7698 18.002 15.9668L16.2715 14.9297ZM5.10352 16.3105L3.68164 17.7324C4.98764 18.8014 6.56592 19.5496 8.29492 19.8516L8.4375 17.8398C7.2005 17.5918 6.06452 17.0595 5.10352 16.3105ZM13.1309 17.3516C12.2949 17.7086 11.3846 17.9285 10.4316 17.9805L10.2891 19.9863C11.6611 19.9473 12.9606 19.621 14.1406 19.082L13.1309 17.3516Z" fill="#fe911e" /></svg></div>';

            // Ajax request
            let request = new XMLHttpRequest();
            request.open("POST", ajax_callback_data.ajax_url, true);
            request.setRequestHeader(
                "Content-Type",
                "application/x-www-form-urlencoded; charset=UTF-8"
            );
            request.onreadystatechange = () => {
                if (request.readyState === 4) {
                    const outputScrollPosition =
                    output.getBoundingClientRect().top + window.scrollY - 88;

                    // Scroll the page to the target position
                    window.scrollTo({
                        top: outputScrollPosition,
                        behavior: "smooth",
                    });
                    data = JSON.parse(request.response);
                    totalPages = data.data.totalPages;
                    currentPage = data.data.currentPage;

                    if (totalPages > currentPage) {
                        loadMoreButton.style.display = "block";
                    } else {
                        loadMoreButton.style.display = "none";
                    }

                    output.innerHTML = data.data.html;
                }
            };
            request.send(
                "action=mesh365_careers&nonce=" +
                ajax_callback_data.ajax_nonce +
                choicesData
            );
        }

        function loadMore(paged) {
            // Output
            let output = document.getElementById("filter-output");
            let loadMoreButton = document.querySelector(".load-more");
            loadMoreButton.setAttribute("data-page", "1");

            let choicesData = "";

            // Ajax request
            let request = new XMLHttpRequest();
            request.open("POST", ajax_callback_data.ajax_url, true);
            request.setRequestHeader(
                "Content-Type",
                "application/x-www-form-urlencoded; charset=UTF-8"
            );
            request.onreadystatechange = () => {
                if (request.readyState === 4) {
                    data = JSON.parse(request.response);
                    totalPages = data.data.totalPages;
                    currentPage = data.data.currentPage;
                    loadMoreButton.setAttribute("data-page", parseInt(currentPage));
                    let loadMoreElement = document.querySelector('.btn-loading');
                    loadMoreElement.remove();
                    if (totalPages > currentPage) {
                        loadMoreButton.style.display = "block";
                    } else {
                        loadMoreButton.style.display = "none";
                    }
                    output.innerHTML += data.data.html;
                }
            };
            request.send(
                "action=mesh365_careers&nonce=" +
                ajax_callback_data.ajax_nonce +
                choicesData +
                "&page=" +
                paged
            );
        }
        
        // Load more click event
        if (page) {
            page.onclick = function () {
                let paged = page.getAttribute("data-page");
                paged++;
                page.setAttribute("data-page", paged);
                let loaderDiv = document.createElement('div');
                loaderDiv.className = 'loader btn-loading w-100';
                loaderDiv.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 0C4.824 0 0.553781 3.954 0.0507812 9H2.06836C2.56336 5.06 5.928 2 10 2C14.072 2 17.4366 5.06 17.9316 9H19.9492C19.4452 3.954 15.176 0 10 0ZM0.0507812 11C0.250781 13.008 1.05458 14.8374 2.26758 16.3184L3.6875 14.8984C2.8295 13.7924 2.25136 12.457 2.06836 11H0.0507812ZM16.2715 14.9297C15.8575 15.4547 15.3855 15.9328 14.8555 16.3398L15.8672 18.0742C16.6802 17.4832 17.399 16.7698 18.002 15.9668L16.2715 14.9297ZM5.10352 16.3105L3.68164 17.7324C4.98764 18.8014 6.56592 19.5496 8.29492 19.8516L8.4375 17.8398C7.2005 17.5918 6.06452 17.0595 5.10352 16.3105ZM13.1309 17.3516C12.2949 17.7086 11.3846 17.9285 10.4316 17.9805L10.2891 19.9863C11.6611 19.9473 12.9606 19.621 14.1406 19.082L13.1309 17.3516Z" fill="#fe911e" /></svg>';
                let loadMoreElement = document.querySelector('.load-more');
                loadMoreElement.parentNode.insertBefore(loaderDiv, loadMoreElement);
                loadMore(paged);
            };
        }
    });
})();